import { useEffect, useRef } from "react";
import { useAuth, useUser } from "@clerk/react";
import { useLocation } from "wouter";
import { isPlayerKioskPath } from "@workspace/observability";
import {
  clearUser,
  initAnalyticsIfConsented,
  setUser,
  trackPageView,
} from "@workspace/observability/web";

import { useWorkspace } from "@/hooks/use-workspace";
import { isDesktopShell } from "@/lib/platform";

export function PageViewTracker() {
  const [location] = useLocation();

  useEffect(() => {
    void initAnalyticsIfConsented();
  }, []);

  useEffect(() => {
    if (isPlayerKioskPath(location)) {
      trackPageView(location, { surface: "player" });
      return;
    }
    trackPageView(location, {
      surface: isDesktopShell() ? "desktop" : "web",
    });
  }, [location]);

  return null;
}

export function ObservabilityUserSync() {
  const { isSignedIn } = useAuth();
  const { user } = useUser();
  const { activeWorkspaceId } = useWorkspace();
  const prevSignedInRef = useRef(isSignedIn);

  useEffect(() => {
    if (!isSignedIn || !user) {
      if (prevSignedInRef.current) {
        clearUser();
      }
      prevSignedInRef.current = isSignedIn;
      return;
    }

    setUser({
      id: user.id,
      email: user.primaryEmailAddress?.emailAddress,
      workspaceId: activeWorkspaceId,
    });
    prevSignedInRef.current = isSignedIn;
  }, [isSignedIn, user, activeWorkspaceId]);

  return null;
}
